import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={21}
    height={20}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.6667 13.3333L18 9.99992M18 9.99992L14.6667 6.66659M18 9.99992L6.33333 9.99992M11.3333 13.3333V14.1666C11.3333 15.5473 10.214 16.6666 8.83333 16.6666H5.5C4.11929 16.6666 3 15.5473 3 14.1666V5.83325C3 4.45254 4.11929 3.33325 5.5 3.33325H8.83333C10.214 3.33325 11.3333 4.45254 11.3333 5.83325V6.66659"
      stroke="#0062FF"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SVGComponent;
